var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"terms"}},[_c('v-main',[_c('v-container',{attrs:{"fluid":"","fill-height":""}})],1),_c('main-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }